// extracted by mini-css-extract-plugin
export default {"box":"EnvironmentInfo_box__PJvhz","title":"EnvironmentInfo_title__Lk8f5"};